export const us = [
    {
        id: "content-us-world-news",
        name: "世界のニュース",
        articles: [
            {
                id: "31b24534-29f6-469f-8ce3-ff774997ef8a",
                class: "columns-3-wide",
                header: "今日起こっています",
                url: "#",
                image: {
                    src: "assets/images/todd-trapani-vS54KomBEJU-unsplash_684.jpg",
                    alt: "プレースホルダー",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                    tag: {
                        type: "breaking",
                        label: "速報",
                    },
                },
                title: "しかし、執行環境生態学的な栄養価の高い熱控除可能。",
                type: "text",
                content: "フットボールポットIDキャリー。さまざまな栄養開発者。メインロレムでさまざまな宿題をするまで。しかし、ウルナソース不動産栄養の地球。ミネアポリス・ロレムは大規模なサピエンの喉と従業員まで。私の時間のバスケットボールでの笑い。",
            },
            {
                id: "06f7b876-6120-4273-8850-f60f817940f0",
                class: "columns-3-narrow",
                header: "トレンド",
                url: "#",
                image: {
                    src: "assets/images/mufid-majnun-tJJIGh703I4-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "偉大なものが必要な人生のシナリオを活性化するために。",
                type: "text",
                content:
                    "それは、バスケットボールで笑いを走らせる特定の製造サッカーではありません。チャンピオンシップDUIライブアルコールトリガードリンクはタンクとして飲みます。直径牛肉まで.\n\nデッキを卒業するための大量開発者. ソースマティス栄養IDニブ温度。 資金調達層のデュオ開発者は、なし。しかし、要素サッカーの抗酸化物質は誰の病気を嫌いますか。",
            },
            {
                id: "e9f3877f-a2a6-41fb-898b-9acb0fdedc19",
                class: "columns-3-narrow",
                header: "天気",
                url: "#",
                image: {
                    src: "assets/images/noaa--urO88VoCRE-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "喉のバレーボールの要素へのトマト唐辛子が綴られました。",
                type: "list",
                content: [
                    {
                        id: "2ed5ca3f-6fca-4061-b055-d79058547e93",
                        content: "栄養居住者サッカー悲しい老年。またはピーナッツティルと憎しみのオルシプロテインバスケットボール。",
                    },
                    {
                        id: "afcab89c-38d8-4d5e-9b52-cd560cb92d96",
                        content: "私は栄養の直径の週末の利便性が嫌いですが、執行執行生態学的です。",
                    },
                    {
                        id: "e9c96309-74a2-4ceb-b0de-8b1a6be4fbdc",
                        content: "子供たちが革新的な化学的痛みを引き出します。矢を味わうための矢印。中国のレースは漫画をパフォーマンスします。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-around-the-nation",
        name: "全国の周り",
        articles: [
            {
                id: "4e19c383-aff6-45de-b874-008c58a9667f",
                class: "columns-3-balanced",
                header: "最新",
                image: {
                    src: "assets/images/fons-heijnsbroek-vBfEZdpEr-E-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ヌラムはサッカーが必要な今、カートンロットが必要です。",
                type: "list",
                content: [
                    {
                        id: "f3197d93-1041-423d-b648-f7b717f7ea9d",
                        content: "ニブ・アルコール写真選手または。オールドとネトゥスとマレスアダの飢er。",
                    },
                    {
                        id: "aa2cfed6-54e2-468d-9a03-dd4db4cab1b4",
                        content: "サッカーサッカーが卒業してすみません。",
                    },
                    {
                        id: "37a7a6b1-710f-45da-a481-2a23c0d90a31",
                        content: "サッカーの写真とサッカーを計画するヴィタエまで. は最新の座りた週末に座っています。",
                    },
                    {
                        id: "48103727-1181-4b8c-b536-062e8a868106",
                        content: "妊娠中のアルコールをチャットしません。それは重要な抗酸化物質であり、臨床的なサッカーのポリシーが大きいことです.",
                    },
                ],
            },
            {
                id: "53c3567d-6073-41e8-87ca-f76a282c38f9",
                class: "columns-3-balanced",
                header: "仕事",
                image: {
                    src: "assets/images/bram-naus-oqnVnI5ixHg-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "栄養開発者の製造範囲。首でカートンチョコレートのウォームアップ。",
                type: "list",
                content: [
                    {
                        id: "2f03cb48-b182-46e7-a651-3bd04ee622bb",
                        content: "正面にある紫色のサッカーマッサージ。彼は人生計画のスケジュールを.",
                    },
                    {
                        id: "4cf064fc-6ad2-4ef4-9bca-ac6607da0912",
                        content: "現在、妊娠中の抗酸化物質や谷の調査飲み物です。ファレトラバレーは、サッカーライオンポットの従業員を要素に設定しました.",
                    },
                    {
                        id: "5fad11d7-ba53-487f-af21-e86b68a98d21",
                        content: "またはバスケットボールDUI SAPIEN。しかし、学部生の悲しい笑顔またはEUまでの学部生の直径。残念ながら、バスケットボールの開発者は、メンバーのメンバーのメンバーではなく、同様です。臨床臨床臨床臨床臨床.",
                    },
                ],
            },
            {
                id: "79344d21-3a1f-4531-87b7-971d0a01e959",
                class: "columns-3-balanced",
                header: "政治",
                image: {
                    src: "assets/images/hansjorg-keller-CQqyv5uldW4-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "局の痛みは非常に機能的です。また、今では不動産ではありません。",
                type: "list",
                content: [
                    {
                        id: "68ad5e3b-68ae-41da-ab0d-a073c78a4ca7",
                        content: "学部生のマイクロ波矢印を控除できる限り、パフォーマンス要素。",
                    },
                    {
                        id: "c48f6f5f-6be3-41ec-a067-c1dc072c0beb",
                        content: "そして、人生の開発者は、常に週末の直径でいつでも卒業した男です。",
                    },
                    {
                        id: "1917cf48-ce4b-4e80-8828-3b104fbacff7",
                        content: "今はソフトですが、それは常に局の笑顔です。大衆の質量ですが、ツイッターの要素ですが、笑顔です。",
                    },
                    {
                        id: "13fb8e39-13c9-4f97-a15f-95bde9351960",
                        content: "それぞれまたは土壌臨床局妊娠中の化粧に常に微笑んでください。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-roundup",
        name: "切り上げする",
        articles: [
            {
                id: "660d5f2a-0977-423b-a585-dbd0f58695e4",
                class: "columns-wrap",
                header: "ワシントン",
                type: "excerpt",
                content: [
                    {
                        id: "bd34fb90-27ff-4e57-b29b-1cec6c56b423",
                        image: {
                            src: "assets/images/unseen-histories-4kYkKW8v8rY-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "しかし、チョコレートフットボールバスケットボールライフ。ミネアポリスの学部開発者宿題の悲しいケア。マッサージをデッキしますが、パッチだけです。素晴らしいウォームアップワークが必要です。",
                    },
                    {
                        id: "30a4e957-4170-4613-8d9a-5b417b999568",
                        image: {
                            src: "assets/images/ian-hutchinson-P8rgDtEFn7s-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "チョコレート全体のサッカー全体の伯爵。タンクとバニーのメールとして。サッカーを卒業したニンジンは、資金調達の執行の不動産です。",
                    },
                    {
                        id: "ffc520db-68a5-451e-89df-86be7e126c10",
                        image: {
                            src: "assets/images/koshu-kunii-ADLj1cyFfV8-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "彼の仲間を妊娠させる必要はありません。モーリス・モーリス・モーリス栄養サッカーサッカー悲しい老年.",
                    },
                ],
            },
            {
                id: "c88e0e0d-e323-4d4e-a0fb-b72c3fda9df8",
                class: "columns-wrap",
                header: "東海岸",
                type: "excerpt",
                content: [
                    {
                        id: "f93e2af2-f8ff-4706-8290-11a2cec073eb",
                        image: {
                            src: "assets/images/matthew-landers-v8UgmRa6UDg-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "しかし、チョコレートフットボールバスケットボールライフ。施行生態学的栄養吸気熱熱。投資臨床ヌラ栄養サッカーは、滅菌されたポットがたくさんあります。タイム臨床サッカーカートンエレメントニブ楽しいテレビは今ではありません。悲しいビッグマンは偉大な​​妊娠中の男性で、走り回って座っています。",
                    },
                    {
                        id: "1298a3c4-6638-4afd-a34c-56ab2eaf281d",
                        image: {
                            src: "assets/images/c-j-1GHqOftzYo0-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "そして、非常にマッサージバスケットボールを執行します。レイヤーのニンジンの開発者にファシリシはありません。ランニングパフォーマンスquisは明日バレーボールロットを引きます。抗酸化物質ですが、病気が嫌いです。このコースでugい走り回っている強大な唐辛子妊娠。",
                    },
                    {
                        id: "5e765702-4e99-4cc5-b958-aad34be0b826",
                        image: {
                            src: "assets/images/jacob-licht-8nA_iHrxHIo-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "地域の整数の学部生をプルします。控除可能な顧客と顧客がいない限り、サッカージャスミンのパフォーマンス要素もいません。無料の週末ですが、明日サッカーはアルコールです。質量をロックしますが、タイムバニーの要素ですが、笑顔の価格。サッカーの価格NIBHテクニックチュートリアルプレーヤーまたは価格。",
                    },
                ],
            },
            {
                id: "a2267128-dd86-4a98-8903-0a887d49104e",
                class: "columns-wrap",
                header: "西海岸",
                type: "excerpt",
                content: [
                    {
                        id: "9c59f003-1eb3-4a86-9a00-9012470c2549",
                        image: {
                            src: "assets/images/maria-lysenko-tZvkSuBleso-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "リンゴ、しかしこの十分の一の漫画地域。製造のプールですが、アークはパフォーマンススカートを嫌いません。明日ニブ・ヴェネナティス、しかしサッカーにはゲームが必要です。バレーボールの要素以上のものは、喉をマッサージするだけではありません。",
                    },
                    {
                        id: "951ecd15-5add-4f8a-8eaf-053be96c923b",
                        image: {
                            src: "assets/images/peter-thomas-17EJD0QdKFI-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "チョコレートを除くプレイヤーの漫画層。バレーはデートライオンポットの従業員を設定しました。しかし、都合の良い時点で湖があります。現在、大衆開発者に資金を提供している最大の利便性。フットボールの週末の憎しみを撃つ.",
                    },
                    {
                        id: "450f1f73-9d36-497a-bab0-6ca7c28c4f68",
                        image: {
                            src: "assets/images/xan-griffin-QxNkzEjB180-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "大衆不動産の宿題の子供たちのパフォーマンス。miはそれぞれを飲むか欲しいです。速いお金契約。さまざまなまたはファレトラまたは醜い.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-crime+justice",
        name: "犯罪と正義",
        articles: [
            {
                id: "bc92acd8-0cbb-42e6-88dc-7589e92eb218",
                class: "columns-3-balanced",
                header: "最高裁判所",
                type: "articles-list",
                content: [
                    {
                        id: "a795ce54-f3f2-4a32-b59d-2a88530638dd",
                        title: "または笑顔や便利さを引っ張ります。",
                        content:
                            "Ollicitudinおよび臨床的ナグの執行Tellusメイクアップ。ミネアポリスAは宿題渓谷の鍋のベッドにいました。どちらのバスケットボールもいません。学部の悲しい笑顔またはEU。今、あなたは塊を座る必要はありません。明日マティスは今、座っています。",
                    },
                    {
                        id: "7add8464-9b82-428a-a8ec-6489b6c4f830",
                        title: "臨床グラブは、最大のものであり、最大の資金を調達しています。",
                        content:
                            "消費者ニンジン補給学部開発者の栄養居住者。明日ニブ・ヴェネナティス、しかしサッカーにはゲームが必要です。のトーマスは、地域の整数の学部生をプルします。フェリスはタンクとして飲み、誰でもマッサージバスケットボールをします。",
                    },
                    {
                        id: "45aa7276-1a3a-4be7-bd1c-c4885dd7e9e0",
                        title: "サッカー開発者のように、いくつかのサラダ生態学のモーリス。",
                        content: "エレメントフットボールの抗酸化物質での痴漢ですが、サッカーは利便性を嫌います。アースメイクアップセラミック栄養サッカー開発者の温度。醜い執従業員は今、座るミサがありません.",
                    },
                ],
            },
            {
                id: "190711e5-6bc8-4b26-920a-b6edd74a0847",
                class: "columns-3-balanced",
                header: "地方法",
                type: "articles-list",
                content: [
                    {
                        id: "a126bcfa-9915-4cd4-8a7f-db36ba5e426e",
                        title: "直径の紫色のまでの多くの治療。",
                        content: "開発者DUIは、段階的なニンジンを飾ります。しかし、私はBlandit Weekend Maecenasの週末に憎んでいます。ポットまたは開発者を入れて、常にであるがバレーボールをしてください。大衆不動産の宿題の子供たちのパフォーマンス。",
                    },
                    {
                        id: "de6f2266-ab8b-4312-b11c-78258500035b",
                        title: "「チリの最新のバスケットボール矢印は常に宿題が必要です。",
                        content:
                            "ロボルティスEUはプロパガンダ化学アークに住んでいます。憎しみの弧の軽cであり、サラダが震えの直径のないことです。サッカー開発者のプロパガンダとして、サラダの生態学的なモーリス。パスポートアークランニングパフォーマンスの各執行の直径すべての漫画。",
                    },
                    {
                        id: "2bac47f6-54c2-4c57-87cc-3a3f202ab290",
                        title: "ご飯の中のチョコレートチョコレートチョコレート。",
                        content: "塊で座ったり、価値があるのではありません。今、チョコレート漫画モーリス。トマトチリを喉の枕に調査してください。それは執行の不動産です。地域では、今のところは喉のバリエッドサッカーを整理する地域で.",
                    },
                ],
            },
            {
                id: "0233b0b6-69f1-4c51-81cd-b849e435f2c1",
                class: "columns-3-balanced",
                header: "意見",
                type: "articles-list",
                content: [
                    {
                        id: "ad0f3eb3-42eb-43f5-bd8d-9a3b62ec5433",
                        title: "優れていて、不動産製造が選択されています。",
                        content:
                            "エネナティス・ウルナランニングは今、チョコレート漫画モーリスを必要としています。谷は、デートライオンポットの従業員を要素に設定しました。フットボールカートンエレメントニブ地域。サッカーマッサージのチリのチップの人生、しかしプールだけですが、漫画。",
                    },
                    {
                        id: "b49fe19d-4bcc-42bb-9b85-8348cc64d4ca",
                        title: "警察はマティスの臨床または開発者でした。谷の端にある恐怖の利便性。",
                        content: "タンクニンジン。最新の唐辛子ニンジンは滅菌しました。今は人生ですが、サッカーのメンバーにお願いします。モーリス・モーリス・モーリス栄養サッカーサッカー悲しい老年。たくさんのスマイリー化学物質。",
                    },
                    {
                        id: "65ca4cde-546a-496a-b731-71140adfb651",
                        title: "サラダ製造の場合、酵母、私または範囲質量。",
                        content: "資金調達をしたいが、パフォーマンスですが、ゲート。または臨床ゲートまたはバレーボールまたはET。urnソース不動産ニブ。チャンピオンはメンバーでもメンバーでもありません。今の人生のチャットの要素ですが、屋外資産。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-around-the-us",
        name: "米国周辺",
        articles: [
            {
                id: "90e08554-f9b4-4606-8e36-55de40b39f9f",
                class: "columns-3-balanced",
                header: "最新",
                image: {
                    src: "assets/images/chloe-taranto-x2zyAOmVNtM-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "強力なものと温度のプルのマイク価格を作成します。",
                type: "list",
                content: [
                    {
                        id: "572e5a00-1754-4fcd-bf5b-b13d781bea45",
                        content: "栄養学部のコンビニエンス開発者でした。サッカーの卒業したニンジンは不動産です。",
                    },
                    {
                        id: "8b1304be-2622-432e-944c-341a9e4fd69d",
                        content: "バニーに投資するために、卒業したニンジンを飾る。ただし、執行環境生態学的プロフェッショナリズムを執行してください。",
                    },
                    {
                        id: "d70f1cd5-2f57-4f85-b967-f15ac4c942cc",
                        content: "ランニングパフォーマンスは明日バレーボールロットを引きます。臨床臨床ヌラ栄養サッカーに投資する臨床が重要です.",
                    },
                    {
                        id: "d9482395-2aef-4e39-9a5c-8d64c4b31b03",
                        content: "一部のサラダとドアのマクロ写真の場合。時々、栄養大衆の不動産宿題のウルトレシーのベリットパフォーマンス.",
                    },
                ],
            },
            {
                id: "9c6014cf-a577-4611-a2ce-97f2b4afc322",
                class: "columns-3-balanced",
                header: "仕事",
                image: {
                    src: "assets/images/razvan-chisu-Ua-agENjmI4-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ベッドのナムプッシュホームワークバレーテルスID。Sem Nulla Quiver直径ニンジンプレーヤー。",
                type: "list",
                content: [
                    {
                        id: "815c097a-ae5e-417e-824f-5dc3f370cd4f",
                        content: "今、子供のニンジンからの喉。idは、多くの時間でマクロプライスプルローションを取得してください。",
                    },
                    {
                        id: "a3b76c87-a288-400e-aeba-c89e97fb82a4",
                        content: "電子レンジが必要ですが、無料です。チョコレートチリは常にこの地域で宿題が必要です。",
                    },
                    {
                        id: "2a4b261c-f04f-4a4f-9d66-5e2d3eca79a3",
                        content: "サッカー開発者のサッカーの大衆には、執行唐辛子が必要です。多くの人生のマクロソースラシニア人は誰でも.",
                    },
                ],
            },
            {
                id: "48cabfe4-6408-488f-b942-8d59d35163f7",
                class: "columns-3-balanced",
                header: "政治",
                image: {
                    src: "assets/images/colin-lloyd-2ULmNrj44QY-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "醜い週末と同様に、公正な資金調達メンバー。NAMの開発者は素晴らしいテレビ期間を持っています。",
                type: "list",
                content: [
                    {
                        id: "7e69389e-794f-4e8b-9dc6-824214437fe6",
                        content: "開発者のサッカーの大衆は、選手の執行唐辛子のレイヤーを必要とします。必須のマティスはゼロです。",
                    },
                    {
                        id: "c72d48b6-a53c-4a86-ac7b-c720d5a63630",
                        content: "ライオン。開発者の栄養居住者のサッカーの悲しい老年を委託します。ソーススカート任意またはピーナッツティルと嫌いタイムオルシ。",
                    },
                    {
                        id: "4fa57fa6-0d49-4c2a-bc0e-fd9b3e21f1bf",
                        content: "ニブ自体の写真撮影プレイヤーの価格。プロパガンダ・モーリス・アウグーまたは妊娠。抱きしめにニンジンを採用します革新的な化学サッカー.",
                    },
                    {
                        id: "7c33aa39-8819-49e8-abd0-53a3dbf8464b",
                        content: "臨床矢印フットボールの週末の憎しみ。多くの補給学部開発者。プロパガンダチョコレートアークのはさまざまな宿題です.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-latest-media",
        name: "最新のメディア",
        articles: [
            {
                id: "92371ddb-b2cf-43e2-8590-bda1440c7025",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "f40d1399-24e7-4dcd-bcd1-663540bd5eae",
                        image: {
                            src: "assets/images/dominic-hampton-_8aRumOixtI-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "15a36d2e-797d-4b0f-8321-c439763fe201",
                        image: {
                            src: "assets/images/sam-mcghee-4siwRamtFAk-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "c46ee0db-4d30-46fc-8a52-c1007bf21cbf",
                        image: {
                            src: "assets/images/adam-whitlock-I9j8Rk-JYFM-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "c3d34280-d796-4039-9d5c-626b09e9b2d9",
                        image: {
                            src: "assets/images/leah-hetteberg-kTVN2l0ZUv8-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-business",
        name: "仕事",
        articles: [
            {
                id: "8e2a8c79-f1dc-4e6c-8542-04684ae08bce",
                class: "columns-3-balanced",
                header: "地元",
                type: "articles-list",
                content: [
                    {
                        id: "f6e0b4f7-77c8-4b14-9454-f20d797b727d",
                        title: "ただし、この十分の一通りの漫画地域。",
                        content:
                            "の追加。直径の週末の利便性ですが、執行施行生態学的な栄養価の高い喉のチョコレート。ullamcorperには、サッカーの直径でさえもファシリシは必要ありません。開発者は、常にがバレーボール電子レンジ妊娠局を紹介します。さまざまなものや震えまたはターピスが必要です。地域の要素のために、生命とライオンの宿題の矢印。",
                    },
                    {
                        id: "82838c69-f2a6-47cd-b6df-dee1909d2019",
                        title: "ポートタートルは、サッカー選手が直径ケアタイムをライオンにします。",
                        content:
                            "航空会社の塊がないよりも直径に。誰が修正するかのための速い学校のバックドッキングはありません。航空会社の大量IDはありません。控除可能な顧客と顧客がいない限り、サッカージャスミンのパフォーマンス要素もいません。バスケットボールも私を必要としません。週末の有毒地域への直径。漏れについては注意しないでください。",
                    },
                    {
                        id: "1a65f23a-485a-4646-a65d-cab6fd1e4603",
                        title: "ライオンまたは臨床ゲートは枕やではありません。",
                        content:
                            "宿題のウルトレシープールを投資しますが。の学部のコンビニエンス開発者は、それだけの価値があります。パッチまたは抗酸化物質の週末。ソーススカート任意のまたはピーナッツまで。栄養居住者サッカー悲しい老年。バスケットボールのピーナッツは、醜い大衆開発者DUIの過程で飾ります。必須の滅菌ポットランニングニーズ。",
                    },
                ],
            },
            {
                id: "5acb5684-4b99-44ff-9668-2e5daec9133c",
                class: "columns-3-balanced",
                header: "グローバル",
                type: "articles-list",
                content: [
                    {
                        id: "a96310f4-89cb-4ea7-a10a-9e03ebbd013e",
                        title: "チェロスプール、パフォーマンスですが、震えはそうではありません、尿を引っ張ります。不動産セットのソース用。",
                        content: "顧客のチームのニンジンが必要です。バレージャスミンと、プルの学部生の笑い声でのマイク。醜いミサの人生のライオン、しかし。今は柔らかいですが、私はそうします。サッカーの時間ターゲットポットIDケア.",
                    },
                    {
                        id: "870d65da-27ab-45f8-9b03-4d5c71e1b31e",
                        title: "バスケットボールの妊娠は、臨床ヌラ栄養を投資するための臨床的です。",
                        content:
                            "マクロなしでマッサージを引くために支払われたマクロを服用してください。しかし、枕の電子レンジは妊娠しています。ウォームアップポットまたは開発者の。中国のチョコレートの世話をセットアップするものは何もありません。チョコレートチリには常に必要です。",
                    },
                    {
                        id: "e6bc4824-319b-4f0e-a3ef-408cc24219eb",
                        title: "明日のサッカーの執行。ムーアは標的を絞ったサピエンを必要とし、サッカーは痛みになります。",
                        content:
                            "モーリスのプロパガンダまたはウォームアップで妊娠しています。サラダゼロの直径にアークの憎しみを飾るのは難しい。タンクと執行バスケットボールを妊娠させた人に誰でも。最新の製造サッカーは、基礎バスケットボールで笑い声を上げています。今では不動産になっていないため、ミサと一緒に座ってはいけません。",
                    },
                ],
            },
            {
                id: "fd9fce73-e286-450f-8fcf-7b988b968f3b",
                class: "columns-3-balanced",
                header: "四半期",
                type: "articles-list",
                content: [
                    {
                        id: "90fc8d03-c410-46f6-ad57-d90f25e199e3",
                        title: "妊娠中の弓と温度資産をチャットしないでください。",
                        content: "今ではそのための不動産です。それによって強化されていません。今の人生のチャンピオンですが、要素の弓の要素。パスポートアークランニングパフォーマンスの各執行の直径すべての漫画。レシピは常に無料で引っ張っています。",
                    },
                    {
                        id: "88c3b366-32e0-4e8b-9735-5dc2194b5e42",
                        title: "残念ながら、キャリアの週末にかかります。時々、空腹と最初の味で。",
                        content:
                            "しかし、バスケットボール、私の時間はマスアダ栄養開発者に必要ではありません。スマイル漫画のジャスミンとマクロ。卒業した大規模なエコロジーポット航空会社レンジチーム。Loremを非常にニンジンを補給している学部開発者を非常に入れてください。のパフォーマンスですが、醜いです。",
                    },
                    {
                        id: "fb087f5c-84d0-4a1a-a9f6-96af0914527d",
                        title: "は一時的にサッカーの宿題です。漫画の臨床または。残念ながら、プレイヤーの写真の価格は引っ張られていません。",
                        content:
                            "今、あなたはロアムの痛みが必要ですが。必須の最新メンバーはあなたのプレイヤーチリであるかもしれません。ミネアポリスの学部開発者は、滅菌した唐辛子のニンジンを滅菌します。臨床的に臨床的に投資する栄養サッカーはありません。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-underscored",
        name: "強調されています",
        articles: [
            {
                id: "f7640582-e9b6-4d47-b396-95515aa0a840",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "2f3a3748-60b2-45b3-b697-2cb4e0a6414d",
                        image: {
                            src: "assets/images/dillon-kydd-2keCPb73aQY-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "時間ターゲットポットプール。男性とモンテスを引っ張るとき。抗酸化物質がたくさんある場合。",
                        url: "#",
                    },
                    {
                        id: "fc5ca351-9505-4cf7-82cc-b176bf9421d3",
                        image: {
                            src: "assets/images/aaron-huber-G7sE2S4Lab4-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "ニンジンの滅菌ポットランニングは、チョコレート漫画のモーリスになりました。臨床の価格は、マクロ価格の漫画を作りたいと考えています。キーボード。",
                        url: "#",
                    },
                ],
            },
            {
                id: "3f4c33ce-8628-46d1-b416-37b0fc218c74",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "f7961c4a-df0b-4d2e-b699-edce14aef7a2",
                        image: {
                            src: "assets/images/mesut-kaya-eOcyhe5-9sQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "パートナーやパルスを妊娠する必要があります。開発者は妊娠する必要があります。今すぐチャットしますが、サッカーのメンバーにお願いします。今すぐチャットしますが、資産をお願いします。または、ライオンよりも選択された人の価格。選択されたマイクロ波ニブニスルソースが選択されたバナナは滅菌されます。",
                        url: "#",
                    },
                    {
                        id: "09287d46-2d4c-4043-a878-086b705da83e",
                        image: {
                            src: "assets/images/diego-jimenez-A-NVHPka9Rk-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "当時の人生のどちらも子供たちよりも、一部の人にとっても。ニブの前面へのストレスが始まります。ただし、サラダがバナナを引くように。ですが、シナリオではバナナを引きます。マティスレンジポットの範囲またはプルだけではありません。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-state-by-state",
        name: "州ごと",
        articles: [
            {
                id: "88c59d52-03e2-47cc-82a0-f0d9df4a88db",
                class: "columns-wrap",
                header: "カリフォルニア",
                type: "excerpt",
                content: [
                    {
                        id: "1f94b398-03e0-46c4-b3db-f89f1076fb8c",
                        image: {
                            src: "assets/images/craig-melville-_JKymnZ1Uc4-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "大量のサピエンの喉または従業員までロレム。ARCは、メインロレムのティルでさまざまな宿題を言ったと言った。現在、子供たちがニンジンの革新的な化学サッカーからの喉。いくつかのサラダの生態学的にチョコレート漫画のマウリスが機能しています",
                    },
                    {
                        id: "6e02b59a-38fb-40f8-9b95-aa0c9eb0bdf4",
                        image: {
                            src: "assets/images/robert-bye-EILw-nEK46k-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "悲しみは、大きな生態学的に卒業した。ソースマティス栄養IDニブトロールID。CNNオレンジまたは開発者チョコレートモーリス栄養。",
                    },
                    {
                        id: "10c89ad8-d9be-4d73-9002-122e504f317c",
                        image: {
                            src: "assets/images/sapan-patel-gmgWd0CgWQI-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "さまざまなサッカーは今です。必須のミネアポリスの学部開発者は、いくつかの唐辛子ニンジンを嘆きます。臨床チョコレートチリは、地域で常に宿題が必要です。",
                    },
                ],
            },
            {
                id: "f28c0060-72db-4588-8b38-9f1b2a01a3ac",
                class: "columns-wrap",
                header: "ニューヨーク",
                type: "excerpt",
                content: [
                    {
                        id: "11a4ac22-47c5-4a55-acc0-fd8ca15a84d8",
                        image: {
                            src: "assets/images/prince-abban-0OUHhvNIbYc-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "各の直径またはバレーボールの要素はそうではありません。局の妊娠中の化粧はそれぞれそれほど臨床的ではありません。",
                    },
                    {
                        id: "77850587-f7e1-4b3c-83c2-f1e705a4eed0",
                        image: {
                            src: "assets/images/quick-ps-sW41y3lETZk-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "CNNセクトプッシュまたはメモ。ミサは現在不動産ではありません。ネットワーク。明日から妊娠している抗酸化物質や谷の耐摩耗性。",
                    },
                    {
                        id: "f407272d-1e0e-4782-9031-aa90f33a5604",
                        image: {
                            src: "assets/images/lorenzo-moschi-N7ypjB7HKIk-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ランニングパフォーマンスプルニブ。マウリス・ニンジンの質量。バイヤー最大の移民とバスケットボール。人生の醜い質量ですが、時間のバニーの要素。常に無料で引っ張ってください。",
                    },
                ],
            },
            {
                id: "bc567ef4-d017-4679-8d7b-c822dd49a3dc",
                class: "columns-wrap",
                header: "ワシントン",
                type: "excerpt",
                content: [
                    {
                        id: "86afb098-dd8b-453b-9e90-68275a4457fc",
                        image: {
                            src: "assets/images/koshu-kunii-v9ferChkC9A-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "今はサッカーですが、プロパガンダは漫画を車に乗せています。しかし、無料ですが、喉は醜いです。マス開発者duiを飾る。重要なことに、飲酒とは、環境の著者である男性全体の補償です。",
                    },
                    {
                        id: "f653d697-a6ce-4e98-b76e-fa9b84bf5546",
                        image: {
                            src: "assets/images/angela-loria-hFc0JEKD4Cc-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "悲しい偉大な人は、ugい座るためにたくさんの妊娠中の男性です。そして、しかし、卒業した製造業は多くのUが望んでいますが。それは正面の笑顔EUの調査です。直径から家畜の家畜の生活がない限り、計画。今、ロボルティスは喉の唐辛子の多くを塊にしています。",
                    },
                    {
                        id: "05e813bd-c4ab-4c30-9922-d90b6d3925a4",
                        image: {
                            src: "assets/images/harold-mendoza-6xafY_AE1LM-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ランニングで醜い大衆開発者DUIを飾ります。ですが、アークはパフォーマンススカートを嫌いません。私の非常に喉の喉や調査または。執行環境の環境栄養補助控除可能。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-hot-topics",
        name: "ホットな話題",
        articles: [
            {
                id: "4a2d747f-a853-4452-82bf-504b5f79a7fe",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "5763aa2d-06a9-4c17-bd6f-c8b9ebb99f18",
                        image: {
                            src: "assets/images/libre-leung-9O0Sp22DF0I-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "素晴らしいと不動産製造。笑い声とサッカーの必要は今ありません。臨床ゲートまたはパルビナーまたは。滅菌滅菌された最新の唐辛子ニンジンは、大きな生態学的な鍋を嘆きました。アークランニングパフォーマンスでは、漫画ニブ。",
                        url: "#",
                    },
                    {
                        id: "71d069ec-a854-41ba-8e68-7d236a2f7810",
                        image: {
                            src: "assets/images/pascal-bullan-M8sQPAfhPdk-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "これは、サピエンの寿命のソースによって滅菌されています。ドゥイはアルコールを生き、タンクとして飲み物を引き起こします。ニンジンを走るラリート・ニンジンはにんじんでした。それは常に局の妊娠中の化粧の笑顔です。誰もがそうではありません。チョコレートからキャリアスキームを置きます。",
                        url: "#",
                    },
                ],
            },
            {
                id: "c897ed90-26b7-4f9d-9c2c-7eb37270a317",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "e1509eb7-5e49-40fb-8581-4cd2d07a697d",
                        image: {
                            src: "assets/images/brooke-lark-HjWzkqW1dgI-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "航空会社の大量IDや一部はありません。寿命マクロソースラシニアの必須ミサ1つ以上。常に滅菌する週末の直径で選択されたゼロ。思いやりのある漏れのいずれかで。",
                        url: "#",
                    },
                    {
                        id: "8107bf22-c893-44e3-a359-2c5d1dcd96f7",
                        image: {
                            src: "assets/images/matthias-heil-lDOEwat_MPs-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "は生命温度のAMETの塊を座らせます。どちらのメンバーもそうすべきではありません。思いやりのある漏れのいずれかで。ITフットボール選手が大切になるまで。ムーアはマウスを逃すために生まれます。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-paid-content",
        name: "有料コンテンツ",
        articles: [
            {
                id: "3acc4e4e-2720-4d9a-aa3e-ec820f6b4f00",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "01e18bfc-4a30-4c5c-bdc1-c7dd8f89a550",
                        image: {
                            src: "assets/images/tadeusz-lakota-Tb38UzCvKCY-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "開発者への資金調達は妊娠する必要があります。開発者は常にを紹介していませんが、バレーボールの履歴書もありません。",
                    },
                ],
            },
            {
                id: "ca777be8-b675-4dc0-817f-972a72129394",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "2ece17ee-a3fc-4400-96e1-4a7571f1a77f",
                        image: {
                            src: "assets/images/leisara-studio-EzzW1oNek-I-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "しかし、明日サッカーはアルコールです。チョコレートのチョコレートでもありました。漫画なし。",
                    },
                ],
            },
            {
                id: "cb0c2767-4955-4cc6-ae13-5c44a958b36f",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "3677b20d-aba5-44b4-b0f7-a286d138305e",
                        image: {
                            src: "assets/images/tamanna-rumee-lpGm415q9JA-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "今、それはいつも局の妊娠中の化粧で笑顔です。そして、私は子供たちの直径の週末の便利さを嫌うまでサッカーですが。",
                    },
                ],
            },
            {
                id: "efe39446-2154-4279-9d1d-66d27db034ac",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "5f1ef3f2-81ea-48e2-8efa-648cc85b4f3d",
                        image: {
                            src: "assets/images/clark-street-mercantile-P3pI6xzovu0-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "常に滅菌する週末の直径で選択されたゼロ。フェリスは今、ミサの多くの味の唐辛子のカートンが必要です。そして、の飢えと醜い。",
                    },
                ],
            },
        ],
    },
];
